import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home1 from "./page/Home1";
import LoginEnter from "./page/LoginEnter";
import Headers from "./components/Headers/Headers";
import {Provider} from 'react-redux';
import { connect, useDispatch , useSelector} from  'react-redux';

import generateStore from  './redux/store'
import PageAdmon from "./page/PageAdmon";
import Contacts from "./page/Contacts";



const store= generateStore()

function App() {
  return (
      

      <Provider store={store}>
        
      <Router>

        <Headers/>
        <Routes>
          <Route path="/" exact element={<Home1/>} />
          <Route path="/home" exact element={<Home1/>} />
          <Route path="/login" exact element={<LoginEnter/>} />
          <Route path= "/admon" exact element = {<PageAdmon/>} />
          <Route path= "/contact" exact element = {<Contacts/>} />
        </Routes>
      </Router>
      </Provider>

    
  );
}

export default App;
